import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import ServicesLanding from "../views/ServicesLanding";
import Environments from "../views/Environments";
import Empowerment from "../views/Empowerment";
import Agriculture from "../views/Agriculture";
import Social from "../views/Social";
import Governance from "../views/Governance";
import Livelihoods from "../views/Livelihoods";	

export default function Services(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServicesLanding/>
		} else if(
			appContext.navSubItem === 'environments' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Environments/>
		} else if(
			appContext.navSubItem === 'empowerment' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Empowerment/>
		} else if(
			appContext.navSubItem === 'agriculture' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Agriculture/>
		} else if(
			appContext.navSubItem === 'social' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Social/>
		} else if(
			appContext.navSubItem === 'governance' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Governance/>
		} else if(
			appContext.navSubItem === 'livelihoods' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Livelihoods/>
		} 
			return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}